import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles, isSP } from 'util/helpers';
import { throttle } from 'lodash';

import Jump from 'components/common/Jump';
import ImageSlide from './components/ImageSlide';
import Feature from './components/Feature';
import Give from './components/Give';
import Map from './components/Map';
import Facility from './components/Facility';
import Notice from './components/Notice';

const displayFacilityScrollWithPC = 1900;
const displayFacilityScrollWithSP = 2100;

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisibleFacility: false,
      scrollOffsetWithFacility: isSP() ? displayFacilityScrollWithSP : displayFacilityScrollWithPC
    }

    this.mapContainerRef = React.createRef();
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    this.initMapAnimation();
    this.initFacility();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollForMap);
    window.removeEventListener('scroll', this.handleScrollForFacility);
  }

  initMapAnimation() {
    this.handleScrollForMap = throttle(() => {
      if (
        this.mapContainerRef.current &&
        this.mapContainerRef.current.getBoundingClientRect().top <
          (isSP() ? window.innerHeight - window.innerWidth : 400)
      ) {
        window.removeEventListener('scroll', this.handleScrollForMap);
        setTimeout(() => this.mapRef.current.setPinsVisible());
      }
    }, 50);

    window.addEventListener('scroll', this.handleScrollForMap);
  }

  initFacility() {
    this.handleScrollForFacility = throttle( () => {
      if (window.pageYOffset > this.state.scrollOffsetWithFacility) {
        this.setState({ isVisibleFacility: true })
      }
    }, 100)

    window.addEventListener('scroll', this.handleScrollForFacility);
  }

  render() {
    const { className } = this.props;
    const { isVisibleFacility } = this.state;

    return (
      <div className={className}>
        <section>
          <ImageSlide />
        </section>
        <section>
          <Notice/>
        </section>
        <section>
          <Feature />
        </section>
        <section>
          <Give />
        </section>
        <section ref={this.mapContainerRef}>
          <Map innerRef={this.mapRef} />
        </section>
        <section>
          { isVisibleFacility && <Facility /> }
        </section>
        <Jump />
      </div>
    );
  }
}

const commonStyle = css`
  overflow-x: hidden;
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  max-width: 1366px;
  margin: 0 auto 112px;
`;

const spStyle = CustomMedia.lessThan('medium')`
`;

export default applyStyles(Home)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/index.js